import React from 'react';
import { AdminH1 } from '../../components/AdminH1';
import PopUpTargetBranchTemplate from '../../components/templates/PopUpTargetBranchTemplate';

export const PopUpTargetBranchAdd = () => (
  <>
    <AdminH1>팝업 문의 지점 추가</AdminH1>
    <PopUpTargetBranchTemplate type={'ADD'} />
  </>
);
